
import { ResultData, ValidateResult } from "@nt-portal/common-sdk";
import { ETenderProcurement, ETenderProcurementPlanService } from "@nt-portal/tcm-sdk";
import { ControllerOptions, DataController } from "../../../../types";
import { BaseClientService } from "../../base-client.service";

export interface ETenderProcurementOptions extends ControllerOptions<ETenderProcurement> {
    organOfState?: string;
}




export class ClientETenderProcurementService extends BaseClientService implements DataController<ETenderProcurement> {

    private _service: ETenderProcurementPlanService;


    constructor() {
        super();
        this._service = new ETenderProcurementPlanService({
            apiService: this.apiService,
            url: this.settings.tcmServer
        });
    }

    public async get(options: ETenderProcurementOptions): Promise<ResultData<ETenderProcurement>> {

        return await this._service.get(this.buildFetchParams(options), this.token, options.filter, options.organOfState);

    }
    public async getLookup(options: ETenderProcurementOptions): Promise<ResultData<ETenderProcurement>> {
        let fetchParams = this.buildLookupFetchParams(options);
        let data = await this._service.get(fetchParams, this.token);
        return data;
    }

    public async getById(options: ETenderProcurementOptions): Promise<ETenderProcurement | null> {
        if (options.id) {
            let item = await this._service.getByProcurementID(options.id, this.token);
            return item;
        }
        return null;
    }
    

     
}